exports.components = {
  "component---src-domain-pages-tsx": () => import("./../../../src/domain/pages.tsx" /* webpackChunkName: "component---src-domain-pages-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-site-map-tsx": () => import("./../../../src/pages/site-map.tsx" /* webpackChunkName: "component---src-pages-site-map-tsx" */)
}

